<!-- Иконка email: конверт для почтового канала поддержки. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M4 6H20V18H4V6Z"
      :stroke="stroke"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M4 7L12 13L20 7"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "EmailIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
